import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  FileCardComponent,
  FileTypeBadgeComponent,
  FilesDisplayComponent,
  FilesListComponent,
  FilesSlideComponent,
} from '@camelot/files-basic';
import { CamDocumentsService, DocumentDto, FileType } from '@camelot/services';
import { EFileExtension, FileData } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

const documentMock: DocumentDto = {
  fileType: FileType.Unknown,
  id: 'doc-1',
  name: 'report.pdf',
  uploadedDate: '2026-01-01T10:00:00Z',
  url: 'https://mock.local/report.pdf',
};

const fileDataMock: FileData = {
  fileExtension: EFileExtension.PDF,
  id: 1,
  name: 'report.pdf',
  type: 'Document',
  url: 'https://mock.local/report.pdf',
};

const documentsServiceMock = {
  documents: {
    get$: () => of([documentMock]),
  },
  fetchDocuments$: () => of([documentMock]),
  getDocuments$: () => of([documentMock]),
};

@Component({
    imports: [
        FileCardComponent,
        FileTypeBadgeComponent,
        FilesDisplayComponent,
        FilesListComponent,
        FilesSlideComponent,
        TestIdDirective,
    ],
    providers: [{ provide: CamDocumentsService, useValue: documentsServiceMock }],
    template: `
    <cam-files-list camTestId="cam-files-list" [files]="this.files" />
    <cam-file-card camTestId="cam-file-card" [file]="this.file" />
    <cam-file-type-badge camTestId="cam-file-type-badge" [fileType]="null" />
    <cam-files-display camTestId="cam-files-display" [documentsIds]="this.documentsIds" />
    <cam-files-slide camTestId="cam-files-slide" [initial]="null" [files]="this.slideFiles" />
  `
})
export class FilesBasicCase {
  public documentsIds = ['doc-1'];
  public file = fileDataMock;
  public files = [fileDataMock];
  public slideFiles: DocumentDto[] = [];
}
